import React from "react";
import api, { MEDIA } from "../../lib/api";
import { toast } from "sonner";
import { Upload, X } from "lucide-react";

const GROUPS = [
    { title: "Site & Branding", fields: [
        ["site_name", "Nume site (folosit în emailuri, header, footer)"],
        ["site_title", "Titlu tab browser (ex: ccashop — Magazin online)"],
        ["tagline", "Tagline (sub logo, în emailuri)"],
        ["site_base_url", "URL complet site (ex: https://ccashop.ro)"],
        ["primary_color", "Culoare primară (hex, ex: #ea580c) — folosită în emailuri"],
        ["logo_url", "Logo — URL sau încarcă fișier", "image"],
        ["favicon_url", "Favicon — URL sau încarcă fișier", "image"],
    ]},
    { title: "Firmă (juridic)", fields: [
        ["company_name", "Nume firmă (juridic)"], ["company_tagline", "Tagline firmă"],
        ["company_cui", "CUI"], ["company_reg_no", "Nr. Reg. Com."],
        ["company_address", "Adresă firmă (juridică)"], ["currency", "Monedă"],
    ]},
    { title: "Contact public", fields: [
        ["contact_phone", "Telefon contact"], ["contact_email", "Email contact"],
        ["contact_address", "Adresă contact"], ["whatsapp_number", "Număr WhatsApp (ex: 40721000000)"],
    ]},
    { title: "Hero / Homepage", fields: [
        ["hero_title", "Titlu principal"], ["hero_subtitle", "Subtitlu principal"],
    ]},
    { title: "Marketing / Tracking", fields: [
        ["google_analytics_id", "Google Analytics ID"], ["meta_pixel_id", "Meta Pixel ID"],
    ]},
    { title: "SMTP (Email)", fields: [
        ["smtp_host", "Host SMTP"], ["smtp_port", "Port", "number"],
        ["smtp_user", "User SMTP"], ["smtp_password", "Parolă SMTP", "password"],
        ["smtp_from", "Email From"],
    ]},
    { title: "SMS (Twilio)", fields: [
        ["twilio_sid", "Twilio SID"], ["twilio_token", "Twilio Token", "password"],
        ["twilio_from", "Număr From"],
    ]},
    { title: "Curierat — FAN Courier", fields: [
        ["fan_courier_enabled", "Fan Courier activ", "boolean"],
        ["fan_courier_client_id", "Client ID (numărul din contul selfAWB)"],
        ["fan_courier_user", "Username selfAWB"],
        ["fan_courier_password", "Parolă selfAWB", "password"],
    ]},
    { title: "Curierat — Cargus", fields: [
        ["cargus_enabled", "Cargus activ", "boolean"],
        ["cargus_username", "Cargus Username"],
        ["cargus_password", "Cargus Parolă", "password"],
        ["cargus_subscription_key", "Ocp-Apim-Subscription-Key", "password"],
    ]},
    { title: "Curierat — Sameday", fields: [
        ["sameday_enabled", "Sameday activ", "boolean"],
        ["sameday_user", "Username Sameday"],
        ["sameday_password", "Parolă Sameday", "password"],
        ["sameday_pickup_point_id", "Pickup Point ID (opțional — auto-detectat dacă e gol)", "number"],
        ["sameday_contact_person_id", "Contact Person ID (opțional — auto-detectat dacă e gol)", "number"],
    ]},
    { title: "Plăți", fields: [
        ["stripe_enabled", "Stripe activ", "boolean"],
        ["stripe_publishable_key", "Stripe Publishable Key"],
        ["stripe_secret_key", "Stripe Secret Key", "password"],
        ["stripe_webhook_secret", "Stripe Webhook Secret", "password"],
        ["netopia_enabled", "Netopia activ", "boolean"],
        ["netopia_signature", "Netopia Signature"],
        ["netopia_public_key", "Netopia Public Key", "textarea"],
        ["cod_enabled", "Ramburs activ", "boolean"],
        ["cod_fee", "Taxă ramburs (RON)", "number"],
    ]},
    { title: "Livrare", fields: [
        ["shipping_cost", "Cost livrare standard (RON)", "number"],
        ["free_shipping_threshold", "Livrare gratuită peste (RON)", "number"],
    ]},
    { title: "Coș abandonat (reminder automat)", fields: [
        ["abandoned_cart_enabled", "Trimite emailuri automat", "boolean"],
        ["abandoned_cart_hours", "După câte ore de inactivitate (ex: 1, 6, 24, 48)", "number"],
        ["abandoned_cart_check_interval_minutes", "Verificare la câte minute (default 30)", "number"],
    ]},
    { title: "Tickete (suport client)", fields: [
        ["tickets_client_chat_enabled", "Permite clienților să răspundă la tickete din contul lor", "boolean"],
    ]},
    { title: "Facturare & TVA", fields: [
        ["vat_payer", "Plătitor de TVA", "boolean"],
        ["default_vat_rate", "Cota TVA implicită (%) (ex: 19, 21, 0 dacă neplătitor)", "number"],
        ["company_bank", "Banca firmă"],
        ["company_iban", "IBAN firmă"],
        ["offer_validity_days", "Valabilitate ofertă (zile)", "number"],
        ["invoicing_provider", "Furnizor e-factură", "select", ["oblio", "smartbill", "fgo"]],
        ["invoicing_api_key", "API Key e-factură", "password"],
        ["invoicing_email", "Email facturare"],
    ]},
    { title: "Opțiuni site", fields: [
        ["promotions_section_active", "Secțiune promoții activă", "boolean"],
        ["auto_confirm_appointments", "Confirmare automată programări", "boolean"],
        ["google_merchant_enabled", "Listare Google Merchant", "boolean"],
        ["blog_enabled", "Blog activ (vizibil în meniu și sitemap)", "boolean"],
        ["portfolio_enabled", "Portofoliu activ (vizibil în meniu și sitemap)", "boolean"],
    ]},
    { title: "Popup bun-venit (primul vizitator)", fields: [
        ["welcome_popup_enabled", "Activează popup", "boolean"],
        ["welcome_popup_title", "Titlu"],
        ["welcome_popup_subtitle", "Subtitlu"],
        ["welcome_popup_code", "Cod reducere (trebuie să existe în secțiunea Coduri)"],
    ]},
    { title: "Social Media", fields: [
        ["social_facebook", "Facebook (URL pagină)"],
        ["social_youtube", "YouTube (URL canal)"],
        ["social_tiktok", "TikTok (URL profil)"],
        ["social_instagram", "Instagram (URL profil)"],
        ["social_linkedin", "LinkedIn (URL pagină)"],
    ]},
    { title: "Footer", fields: [
        ["footer_legal_text", "Text juridic footer (clauze, mențiuni legale)", "textarea",
         "Variabile disponibile: {company_name} {site_name} {site_url} {company_cui} {company_reg_no} {company_address} {contact_email} {contact_phone} {current_year}"],
    ]},
    { title: "Pagini statice", fields: [
        ["about_us", "Despre noi", "textarea"],
        ["terms_content", "Termeni și condiții", "textarea"],
        ["gdpr_content", "Politica GDPR", "textarea"],
        ["return_policy_content", "Politică retur", "textarea"],
    ]},
];

export default function AdminSettings() {
    const [settings, setSettings] = React.useState({});
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => { api.get("/admin/settings").then(r => setSettings(r.data || {})); }, []);

    const save = async () => {
        setLoading(true);
        try {
            await api.put("/admin/settings", settings);
            toast.success("Setări salvate");
        } catch { toast.error("Eroare"); }
        setLoading(false);
    };

    const set = (k, v) => setSettings(s => ({ ...s, [k]: v }));

    const uploadImg = async (key, file) => {
        const fd = new FormData(); fd.append("file", file);
        try {
            const res = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
            set(key, res.data.url);
            toast.success("Imagine încărcată");
        } catch { toast.error("Eroare la upload"); }
    };

    return (
        <div data-testid="admin-settings">
            <div className="overline mb-2">Administrare</div>
            <h1 className="font-heading text-3xl uppercase mb-6">Setări site</h1>
            <div className="space-y-6 max-w-4xl">
                {GROUPS.map(g => (
                    <div key={g.title} className="border-2 border-foreground">
                        <div className="bg-foreground text-background px-4 py-2 font-heading uppercase">{g.title}</div>
                        <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-3">
                            {g.fields.map(([key, label, type, options]) => (
                                <div key={key} className={type === "textarea" ? "md:col-span-2" : ""}>
                                    <label className="block font-mono text-[11px] uppercase tracking-wide text-muted-foreground mb-1">{label}</label>
                                    {type === "textarea" ? (
                                        <>
                                        <textarea rows="4" value={settings[key] || ""} onChange={(e) => set(key, e.target.value)} className="w-full px-3 py-2 border border-foreground bg-transparent text-sm" />
                                        {typeof options === "string" && <p className="text-[11px] text-muted-foreground mt-1 font-mono">{options}</p>}
                                        </>
                                    ) : type === "boolean" ? (
                                        <label className="flex items-center gap-2"><input type="checkbox" checked={!!settings[key]} onChange={(e) => set(key, e.target.checked)} /><span className="text-sm">Activ</span></label>
                                    ) : type === "number" ? (
                                        <input type="number" value={settings[key] || ""} onChange={(e) => set(key, Number(e.target.value))} className="w-full px-3 py-2 border border-foreground bg-transparent text-sm" />
                                    ) : type === "select" ? (
                                        <select value={settings[key] || ""} onChange={(e) => set(key, e.target.value)} className="w-full px-3 py-2 border border-foreground bg-transparent text-sm">
                                            {(options || []).map(o => <option key={o}>{o}</option>)}
                                        </select>
                                    ) : type === "image" ? (
                                        <div className="flex items-center gap-2">
                                            {settings[key] && (
                                                <div className="relative">
                                                    <img src={settings[key].startsWith("http") ? settings[key] : MEDIA(settings[key])}
                                                         alt="" className="w-16 h-16 object-contain border border-border rounded-lg bg-white" />
                                                    <button onClick={() => set(key, "")} title="Șterge"
                                                            className="absolute -top-1 -right-1 bg-destructive text-destructive-foreground rounded-full p-0.5">
                                                        <X className="h-3 w-3" />
                                                    </button>
                                                </div>
                                            )}
                                            <input value={settings[key] || ""} onChange={(e) => set(key, e.target.value)}
                                                   placeholder="URL sau încarcă fișier"
                                                   className="flex-1 px-3 py-2 border border-foreground bg-transparent text-sm" />
                                            <label className="btn-outline cursor-pointer text-xs flex items-center gap-1 shrink-0">
                                                <Upload className="h-3 w-3" /> Încarcă
                                                <input type="file" accept="image/*" className="hidden"
                                                       onChange={(e) => e.target.files[0] && uploadImg(key, e.target.files[0])} />
                                            </label>
                                        </div>
                                    ) : (
                                        <input type={type || "text"} value={settings[key] || ""} onChange={(e) => set(key, e.target.value)} className="w-full px-3 py-2 border border-foreground bg-transparent text-sm" data-testid={`setting-${key}`} />
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
                <button onClick={save} disabled={loading} className="btn-primary" data-testid="settings-save">{loading ? "Se salvează..." : "Salvează setările"}</button>
            </div>
        </div>
    );
}
